import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import userSlice from "../auth/userSlice";
import roeSlice from "../features/proformaInvoice/roe/roeSlice";
import statusMasterSlice from "../features/common/statusMasterSlice";
export const store = configureStore({
    reducer: {
        userSlice: userSlice,
        roeSlice: roeSlice,
        statusMasterSlice: statusMasterSlice
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AddDispatch = typeof store.dispatch;

export const useAddDispatch = () => useDispatch<AddDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;